import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Paper,
  Divider,
  Chip,
  Avatar
} from '@mui/material';
import {
  HourglassEmpty,
  Settings,
  Verified,
  DoneAll,
  Close,
  Description
} from '@mui/icons-material';

const ApplicationStatusTracker = ({ data, id }) => {
  const [activeStep, setActiveStep] = useState(0);

  const dumpData = [
    {
      status: "Pending",
      time: "10:00 AM",
      date: "2025-04-01"
    },
    {
      status: "Review",
      time: "11:30 AM",
      date: "2025-04-02"
    },
  ];

  const statusMapping = [
    {
      status: "pending",
      label: "Pending",
      description: "Your application has been submitted and is awaiting review",
      icon: <HourglassEmpty />
    },
    {
      status: "process",
      label: "Process",
      description: "Your application is being reviewed by Al-Kauser",
      icon: <Settings />
    },
    {
      status: "approved",
      label: "Approved",
      description: "Your application has been approved by Al-Kauser!",
      icon: <Verified />
    },
    {
      status: "rejected",
      label: "Rejected",
      description: "Your application has been rejected.",
      icon: <Close />
    },
    {
      status: "paid",
      label: "Completed",
      description: "Application completed successfully",
      icon: <DoneAll />
    }
  ];

  const filteredStatus = (() => {
    const rejectedIndex = data.findIndex(item => item.status === 'Rejected');
    if (rejectedIndex !== -1) {
      const rejectedStatus = data.slice(0, rejectedIndex + 1);
      return statusMapping.filter(step =>
        rejectedStatus.find(data => data.status === step.status)
      );
    } else {
      return statusMapping.filter(step =>
        data.find(data => data.status === step.status)
      );
    }
  })();

  useEffect(() => {
    const lastStatusIndex = data.length - 1;
    setActiveStep(lastStatusIndex);
  }, [data]);

  return (
    <Paper elevation={3} sx={{ maxWidth: 600, margin: 'auto', p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Description sx={{ fontSize: 40, mr: 2, color: "#388e3c" }} />
          <Typography variant="h5">
            <Box component="span" sx={{ fontWeight: 500 }}>Application Status:</Box>
          </Typography>
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 500 }}>#{id}</Typography>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Stepper activeStep={activeStep} orientation="vertical">
        {filteredStatus.map((step, index) => {
          const matched = data.find(data => data.status === step.status);
          const isRejected = step.status === 'rejected';

          return (
            <Step key={step.status} completed={index < activeStep}>
              <StepLabel
                StepIconComponent={() => (
                  <Avatar sx={{ bgcolor: isRejected ? 'error.main' : '#388e3c', color: 'white' }}>
                    {step.icon}
                  </Avatar>
                )}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle1" color={isRejected ? 'error.main' : 'inherit'}>
                    {step.label}
                  </Typography>
                  <Typography variant="body2">
                    {matched?.date} {matched?.time}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  {step.description}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Paper>
  );
};

export default ApplicationStatusTracker;
